import * as libOrganization from '../domain/organization';
import { VoteOptionToString } from '../domain/pollOption';
import * as libProposal from '../domain/proposal';
export const VoteCommentsColumns = [
    { header: 'Organization title', key: 'orgTitle', width: 20 },
    { header: 'Poll title', key: 'pollTitle', width: 20 },
    { header: 'Poll classification tags', key: 'classificationTags', width: 20 },
    { header: 'Comment', key: 'comment', width: 20 },
    { header: 'Vote', key: 'investorVote', width: 10 },
];
export const voteCommentsFromHabitats = (habitats, fetchAnonymizedCommentsResponse) => {
    const voteCommentsSheets = habitats.map((h) => {
        const habitatVoteComments = fetchAnonymizedCommentsResponse.voteCommentsByHabitat[h.name];
        const data = pollVoteCommentsToVoteCommentRows(habitatVoteComments.pollVoteComments, fetchAnonymizedCommentsResponse.polls, fetchAnonymizedCommentsResponse.proposals, fetchAnonymizedCommentsResponse.organizations);
        return {
            title: `C|${h.title}`,
            headers: VoteCommentsColumns,
            data,
        };
    });
    return voteCommentsSheets;
};
export const voteCommentsFromSchemes = (schemes, fetchAnonymizedCommentsResponse) => {
    const voteCommentsSheets = schemes.map((s) => {
        const schemeVoteComments = fetchAnonymizedCommentsResponse.voteCommentsByScheme[s.name];
        const data = pollVoteCommentsToVoteCommentRows(schemeVoteComments.pollVoteComments, fetchAnonymizedCommentsResponse.polls, fetchAnonymizedCommentsResponse.proposals, fetchAnonymizedCommentsResponse.organizations);
        return {
            title: `C|${s.title}`,
            headers: VoteCommentsColumns,
            data,
        };
    });
    return voteCommentsSheets;
};
export const summaryVoteCommentsSheet = (fetchAnonymizedCommentsResponse) => {
    const data = pollVoteCommentsToVoteCommentRows(fetchAnonymizedCommentsResponse.summary, fetchAnonymizedCommentsResponse.polls, fetchAnonymizedCommentsResponse.proposals, fetchAnonymizedCommentsResponse.organizations);
    const summaryVoteCommentsSheet = {
        title: 'C|Summary',
        headers: VoteCommentsColumns,
        data,
    };
    return summaryVoteCommentsSheet;
};
export const pollVoteCommentsToVoteCommentRows = (pollVoteComments, polls, proposals, organizations) => {
    return pollVoteComments
        .map((pvc) => {
        const poll = polls[pvc.pollName];
        const proposal = proposals[poll.proposalName];
        const { organizationID } = libProposal.nameToID(proposal.name);
        const organization = organizations[libOrganization.IDToName({ organizationID })];
        return pvc.voteCommentPairs
            .map((vcp) => ({
            orgTitle: organization.legalTitle,
            pollTitle: poll.title,
            classificationTags: poll.classificationTags.map((t) => t.title).join('|'),
            comment: vcp.comment,
            investorVote: VoteOptionToString(vcp.vote),
        }))
            .flat();
    })
        .flat();
};
